'use strict';

var React = require('react'),
    ReactDOM = require('react-dom'),
    RectIcon = require('../Icon/RectIcon'),
    MixinKeyboardUserEvent = require('../../mixins/KeyboardUserEvent'),
    _ = require('lodash');

var Dialog = React.createClass({
    displayName: 'Dialog',


    mixins: [MixinKeyboardUserEvent],

    getInitialState: function getInitialState() {
        return {
            showing: true
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            onOpen: function onOpen() {},
            onClose: function onClose() {},
            showClose: true,
            width: undefined, //Number or string "MAX"
            backdrop: true,
            template: "",
            preventClose: false,
            id: ""
        };
    },

    componentWillMount: function componentWillMount() {
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    },

    componentDidMount: function componentDidMount() {
        if (!this.props.preventClose) {
            DialogController.registerToCloseOnBackButton();
        }

        if (this.props.id == "") {
            document.body.style.overflow = 'hidden';
        }
    },

    componentWillUnmount: function componentWillUnmount() {
        if (!this.props.preventClose) {
            DialogController.unRegisterToCloseOnBackButton();
        }
        document.body.style.overflow = 'auto';
    },

    onKeyboardKeyDown: function onKeyboardKeyDown(event) {
        if (event.keyCode == 27 && !this.props.preventClose) {
            this._callClose();
        }
    },

    close: function close(params) {
        var state = this.state;
        if (!state.showing) {
            return false;
        }

        state.showing = false;
        this.setState(state);

        if (this.props.onClose) {
            this.props.onClose(params);
        }
    },

    _callClose: function _callClose() {
        DialogController.closeDialog();
    },

    renderClose: function renderClose() {
        if (this.props.showClose) return React.createElement(RectIcon, { className: 'dialog-close', onClick: this._callClose, imgSrc: 'img/icoDialogClose.png' });
    },

    render: function render() {

        var widthClass = "width-auto";
        var widthStyle = {};
        if (this.props.width) {
            if (_.isNumber(this.props.width)) {
                widthStyle.width = this.props.width + "px";
            } else if (this.props.width.trim().toLowerCase() == "max") {
                widthClass = "width-max";
            }
        }

        var style = { "display": this.state.showing ? "block" : "none" };

        return React.createElement(
            'div',
            { className: 'dialog-wrap ' + (this.props.backdrop ? 'backdrop' : ''), style: style },
            React.createElement(
                'div',
                { className: 'dialog-wrap-tbl' },
                React.createElement(
                    'div',
                    { className: 'dialog-wrap-tbl-cell' },
                    React.createElement(
                        'div',
                        { className: "dialog " + widthClass, style: widthStyle },
                        this.renderClose(),
                        this.props.template
                    )
                )
            )
        );
    }
});

/* Important: Use DialogHeader & DialogContent components to wrap relevant sections in the component you pass DialogController */
var DialogController = {
    dialog: undefined,

    closeDialog: function closeDialog(params) {
        if (this.dialog && _.isFunction(this.dialog.close)) {
            this.dialog.close(params);
        }

        if (this.dialog) {
            setTimeout(function () {
                ReactDOM.unmountComponentAtNode(document.getElementById("dialog-place-holder"));
            }, 100);
        }
    },

    //General functionalety for all pages..
    openDialog: function openDialog(component, options) {
        if (!options) {
            options = {};
        }

        var showClose = options.showClose != undefined ? options.showClose : true;

        var onOpen = options.onOpen || function () {};
        var onClose = options.onClose || function () {};
        var width = options.width || undefined;
        var preventClose = options.preventClose || undefined;
        var id = options.id || "";

        if (options.id) {
            this.dialog = ReactDOM.render(React.createElement(Dialog, { template: component, onOpen: onOpen, onClose: onClose, width: width, showClose: showClose, preventClose: preventClose, id: id }), document.getElementById(options.id));
        } else {
            this.dialog = ReactDOM.render(React.createElement(Dialog, { template: component, onOpen: onOpen, onClose: onClose, width: width, showClose: showClose, preventClose: preventClose }), document.getElementById('dialog-place-holder'));
        }
    },

    registerToCloseOnBackButton: function registerToCloseOnBackButton() {
        window.history.pushState({ dialog: true }, document.title, window.location.href);
        window.addEventListener('popstate', this.closeDialog.bind(this));
    },

    unRegisterToCloseOnBackButton: function unRegisterToCloseOnBackButton() {
        if (window.history.state && window.history.state.dialog) {
            window.history.back();
        }
        window.removeEventListener('popstate', this.closeDialog);
    }
};

module.exports = {
    Dialog: Dialog,
    DialogController: DialogController
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Dialog/Dialog.js
// module id = 30
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30